var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"dashboard-widget-fluid"},[_vm._t("title",[_c('h5',[_c('b',[_vm._v(_vm._s(_vm.title))])])]),_vm._t("content",[_vm._v(" "+_vm._s(_vm.content)+" ")])],2)}
var staticRenderFns = []

export { render, staticRenderFns }